import { render, staticRenderFns } from "./Form13.vue?vue&type=template&id=183091a6&scoped=true&"
import script from "./Form13.vue?vue&type=script&lang=ts&"
export * from "./Form13.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183091a6",
  null
  
)

export default component.exports